import React from "react";
import "./style.scss";
import { useState } from "react";
import { useEffect } from "react";
import { FaBasketShopping, FaRegClock } from "react-icons/fa6";
import { BsCartX } from "react-icons/bs";
import { TbTruckDelivery } from "react-icons/tb";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { BsPencil } from "react-icons/bs";
import { RiDeleteBin6Line } from "react-icons/ri";
import { Formatter } from "utils/formatter";
import Pagination from "@mui/material/Pagination";
import { Link } from "react-router-dom";
import {
  getAllOrders,
  getOrderByOrderStatusID,
  updateOrderStatusAPI,
  getDetailOrderByID,
  getRefundPendingOrders,
  getRefundLink,
  updateRefundStatus,
  getRefundCompletedOrders,
  cancelOrder,
} from "services/admin/orderService";
import { FormatDateHours } from "utils/formatDate";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { PacmanLoader } from "react-spinners";
import { IoIosCloseCircle } from "react-icons/io";
import Notification from "component/user/notification/notification";
import Swal from "sweetalert2";
import { getCountAllOrderStatus } from "services/admin/dashboardService";
import { Modal } from "react-bootstrap";
import { introspective } from "services/tokenService";

const OrderList = () => {
  const [selectedStatus, setSelectedStatus] = useState("all");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [orders, setOrders] = useState([]);
  // const [isHidden, setIsHidden] = useState(false);
  const [hiddenRows, setHiddenRows] = useState({});

  const [orderDetails, setOrderDetails] = useState(null);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const [showRefundModal, setShowRefundModal] = useState(false);
  const [selectedReason, setSelectedReason] = useState("");

  const openDetailsModal = () => setIsDetailsModalOpen(true);
  const closeDetailsModal = () => setIsDetailsModalOpen(false);

  const openRefundModal = () => setShowRefundModal(true);
  const closeRefundModal = () => setShowRefundModal(false);

  const [openDropdown, setOpenDropdown] = useState(null);
  const [orderStats, setOrderStats] = useState([]);
  const [refundLink, setRefundLink] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const [currentOrderID, setCurrentOrderID] = useState(null);

  const [showCancelModal, setShowCancelModal] = useState(false);
  const [cancelOrderID, setCancelOrderID] = useState(null);
  const [cancelReasons, setCancelReasons] = useState([]); // Lý do hủy hiện tại

  const [orderPermission, setOrderPermission] = useState(""); // lưu xem có quyền qly sách không
 
    useEffect(() => {
        const fetchPermissions = async () => {
            try {
                const response = await introspective(token);
                if (response.data) {
                  setOrderPermission(response.data.permissions.some(permission => permission.id === 1)); // id 2 là sách
                }
            }
            catch (error) {
                console.log("introspective failed:", error);
            }
        };
 
        fetchPermissions();
 
    }, [token]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getCountAllOrderStatus(token);
        setOrderStats(response.data); // Lưu dữ liệu vào state
      } catch (error) {
        console.error("Error fetching order status:", error);
      }
    };

    fetchData();
  }, [token]);

  const getOptions = (currentStatus) => {
    const statusTransitions = {
      "Chờ xác nhận": ["Đang đóng gói", "Hủy đơn"],
      "Đang đóng gói": ["Đang vận chuyển", "Hủy đơn"],
      "Đang vận chuyển": ["Đã giao", "Hủy đơn"],
      "Đã giao": [],
      "Đã hủy": [],
      "Đã hoàn thành": [],
    };
    return statusTransitions[currentStatus] || [];
  };

  const openCancelReasonModal = (orderID, orderStatus) => {
    setCancelOrderID(orderID);

    // Xác định danh sách lý do hủy dựa trên trạng thái đơn hàng
    if (orderStatus === "Chờ xác nhận") {
      setCancelReasons([{ reasonID: 5, reason: "Hết hàng" }]);
    } else if (orderStatus === "Đang vận chuyển") {
      setCancelReasons([
        { reasonID: 9, reason: "Đối tác giao hàng không thể nhận đơn hàng" },
        { reasonID: 10, reason: "Khách hàng không nhận hàng" },
        { reasonID: 11, reason: "Đơn hàng bị hỏng trên đường giao" },
      ]);
    } else if (orderStatus === "Đang đóng gói") {
      setCancelReasons([
        { reasonID: 6, reason: "Lỗi đóng gói sản phẩm" },
        {
          reasonID: 7,
          reason:
            "Lỗi thông tin đơn hàng (địa chỉ giao hàng sai, thông tin khách hàng thiếu)",
        },
      ]);
    }

    setShowCancelModal(true); // Mở modal
  };

  const closeCancelReasonModal = () => {
    setShowCancelModal(false); // Đóng modal
  };

  const handleCancelOrder = async (cancelOrderID, selectedReason) => {

    if (!cancelOrderID) {
      Swal.fire({
        icon: "error",
        title: "Lỗi",
        text: "Không tìm thấy ID đơn hàng!",
      });
      return;
    }
    if (!selectedReason) {
      Swal.fire({
        icon: "error",
        title: "Lỗi",
        text: "Vui lòng chọn lý do hủy đơn!",
      });
      return;
    }

    console.log("id lí do hủy", selectedReason.reasonID);
    try {
      setIsLoading(true);
      const response = await cancelOrder(
        token,
        cancelOrderID,
        selectedReason.reasonID
      );

      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Thành công!",
          text: "Đơn hàng đã được hủy!",
          timer: 3000,
          showConfirmButton: false,
        });

        // Cập nhật danh sách đơn hàng
        const updatedOrders = orders.map((order) =>
          order.orderID === cancelOrderID
            ? { ...order, orderStatus: "Đã hủy", cancelReason: selectedReason }
            : order
        );
        setOrders(updatedOrders);
      }
    } catch (error) {
      console.error("Lỗi khi hủy đơn hàng:", error);
    } finally {
      setIsLoading(false);
      closeCancelReasonModal();
    }
  };

  //cập nhật trạng thái đơn hàng
  const handleOptionClick = async (orderID, selectedOption, orderStatus) => {
    console.log(`Order ID: ${orderID}, New Status: ${selectedOption}`);

    if (selectedOption === "Hủy đơn") {
      openCancelReasonModal(orderID, orderStatus);
      return;
    }

    let status;
    if (selectedOption === "Đã giao") {
      status = 4;
    } else if (selectedOption === "Đang vận chuyển") {
      status = 3;
    } else if (selectedOption === "Đang đóng gói") {
      status = 2;
    } else if (selectedOption === "Đã hủy") {
      status = 6;
    }

    try {
      setIsLoading(true);
      const response = await updateOrderStatusAPI(token, orderID, status);
      // console.log("updat", response.data);
      // Cập nhật trạng thái trong danh sách orders
      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Thành công!",
          text: "Thay đổi trạng thái đơn hàng thành công!",
          timer: 3000,
          timerProgressBar: true,
          showConfirmButton: false,
          customClass: {
            popup: "my-swal", // Liên kết với lớp CSS
          },
        });

        const updatedOrders = orders.map((order) => {
          if (order.orderID === orderID) {
            return {
              ...order,
              orderStatus: response.data.data.split(":")[1].trim(), // Cập nhật orderStatus từ response
            };
          }
          return order;
        });
        setOrders(updatedOrders);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
    setOpenDropdown(null); // Đóng dropdown sau khi chọn xong
  };

  const handleStatusChange = (event) => {
    console.log("event", event.target.value);
    setSelectedStatus(event.target.value);
    navigate(`/admin/list-order/${event.target.value}`);
    setCurrentPage(0); // Reset trang về 0 khi thay đổi trạng thái đơn hàng
  };
  const fetchOrders = async () => {
    try {
      setIsLoading(true);
      let orderStatusID;

      switch (selectedStatus) {
        case "pending":
          orderStatusID = 1;
          break;
        case "packing":
          orderStatusID = 2;
          break;
        case "shipping":
          orderStatusID = 3;
          break;
        case "delivered":
          orderStatusID = 4;
          break;
        case "cancelled":
          orderStatusID = 6;
          break;
        case "refund_pending":
          const refundData = await getRefundPendingOrders(token, currentPage);
          setOrders(refundData.data.content);
          setTotalPages(refundData.data.page.totalPages);
          return;
        case "refund_completed":
          const refundCompletedData = await getRefundCompletedOrders(
            token,
            currentPage
          );
          setOrders(refundCompletedData.data.content);
          setTotalPages(refundCompletedData.data.page.totalPages);
          return;
        default:
          // Không có trạng thái hợp lệ, gọi API lấy tất cả đơn hàng.
          const response = await getAllOrders(token, currentPage);
          setOrders(response.data.content);
          setTotalPages(response.data.page.totalPages);
          return;
      }

      if (orderStatusID !== undefined) {
        const data = await getOrderByOrderStatusID(
          token,
          orderStatusID,
          currentPage
        );
        setOrders(data.data.content);
        setTotalPages(data.data.page.totalPages);
      }
    } catch (error) {
      console.error("Error fetching orders:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleRefundAction = async (orderID) => {
    console.log(`Processing refund for order ID: ${orderID}`);
    try {
      setIsLoading(true); // Hiển thị trạng thái đang tải
      const refundLink = await getRefundLink(token, orderID);
      console.log(`Refund link for order ${orderID}:`, refundLink.data);
      setRefundLink(refundLink.data);
      openRefundModal(true);
      setCurrentOrderID(orderID);
    } catch (error) {
      console.error("Error generating refund link:", error);
      alert("Không thể tạo liên kết hoàn tiền. Vui lòng thử lại!");
    } finally {
      setIsLoading(false); // Tắt trạng thái đang tải
    }
  };

  const handleRefundStatusChange = async (status) => {
    const orderID = currentOrderID;
    const confirmMessage =
      status === "completed"
        ? "Bạn có chắc chắn hoàn tiền cho đơn hàng này?"
        : "Bạn có chắc chắn tài khoản ngân hàng không hợp lệ?";

    const result = await Swal.fire({
      title: "Xác nhận hành động",
      text: confirmMessage,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Xác nhận",
      cancelButtonText: "Hủy",
      allowOutsideClick: false,
      stopKeydownPropagation: true,
    });

    if (result.isConfirmed) {
      try {
        setIsLoading(true);
        let response;
        if (status === "completed") {
          response = await updateRefundStatus(token, orderID, true);
        } else if (status === "bank_error") {
          response = await updateRefundStatus(token, orderID, false);
        }
        if (response && response.status === 200) {
          // Nếu mã trạng thái là 200, hiển thị thông báo thành công
          if (status === "completed") {
            Swal.fire("Thành công!", "Đã hoàn tiền cho đơn hàng", "success");
          } else if (status === "bank_error") {
            Swal.fire(
              "Thành công!",
              "Đã ghi nhận lỗi sai thông tin tài khoản ngân hàng",
              "success"
            );
          }
          setOrders((prevOrders) =>
            prevOrders.filter((order) => order.orderID !== orderID)
          );
        } else {
          // Nếu không nhận được mã 200, hiển thị thông báo lỗi
          Swal.fire(
            "Lỗi!",
            "Đã xảy ra lỗi khi cập nhật trạng thái hoàn tiền",
            "error"
          );
        }
      } catch (error) {
        console.error("Error updating refund status:", error);
        Swal.fire("Lỗi", "Đã có lỗi xảy ra khi cập nhật trạng thái", "error");
      } finally {
        setIsLoading(false); // Tắt trạng thái đang tải
        closeRefundModal(false);
      }
    } else {
      console.log("Hành động đã bị hủy");
    }
  };

  useEffect(() => {
    fetchOrders(); // Gọi hàm fetchOrders khi trạng thái hoặc trang thay đổi
  }, [selectedStatus, currentPage]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const fetchOrderDetails = async (orderID) => {
    try {
      setIsLoading(true);
      const response = await getDetailOrderByID(token, orderID);
      setOrderDetails(response.data);
      setIsDetailsModalOpen(true);
    } catch (error) {
      console.error("Lỗi khi lấy chi tiết đơn hàng:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const getCountByStatus = (status) => {
    const order = orderStats.find((item) => item.status === status);
    return order ? order.count : 0; // Nếu không tìm thấy thì trả về 0
  };

  return (
    <>
      <div className="OrderList">
        <div className="dashboardBoxWrapper d-flex mt-5">
          <div className="dashboardBox col">
            <div className="row w-100 m-0">
              <div className="col-lg-4 d-flex align-items-center">
                <div className="avatar-md rounded color2">
                  <FaBasketShopping />
                </div>
              </div>
              <div className="col-lg-8 text-end flex-col align-items-center pe-3">
                <p>Tổng đơn hàng</p>
                <h3 className="m-0">{getCountByStatus("Tất cả")}</h3>
              </div>
            </div>
          </div>

          <div className="dashboardBox col">
            <div className="row w-100 m-0">
              <div className="col-lg-4 d-flex align-items-center">
                <div className="avatar-md rounded color1">
                  <FaRegClock />
                </div>
              </div>
              <div className="col-lg-8 text-end flex-col align-items-center pe-3">
                <p>Chờ xác nhận</p>
                <h3 className="m-0">{getCountByStatus("Chờ xác nhận")}</h3>
              </div>
            </div>
          </div>

          <div className="dashboardBox col">
            <div className="row w-100 m-0">
              <div className="col-lg-4 d-flex align-items-center">
                <div className="avatar-md rounded color4">
                  <TbTruckDelivery />
                </div>
              </div>
              <div className="col-lg-8 text-end flex-col align-items-center pe-3">
                <p>Đang vận chuyển</p>
                <h3 className="m-0">{getCountByStatus("Đang vận chuyển")}</h3>
              </div>
            </div>
          </div>

          <div className="dashboardBox col">
            <div className="row w-100 m-0">
              <div className="col-lg-4 d-flex align-items-center">
                <div className="avatar-md rounded color5">
                  <BsCartX />
                </div>
              </div>
              <div className="col-lg-8 text-end flex-col align-items-center pe-3">
                <p>Đơn hàng đã huỷ</p>
                <h3 className="m-0">{getCountByStatus("Đã hủy")}</h3>
              </div>
            </div>
          </div>
        </div>

        <div className="card border-0 p-4 mt-5 mb-5">
          <div className="headCard d-flex">
            <select
              id="orderSelect"
              name="orderSelect"
              className="custom-combobox"
              value={selectedStatus}
              onChange={handleStatusChange}
            >
              <option value="all">Tất cả đơn hàng</option>
              <option value="pending">Chờ xác nhận</option>
              <option value="packing">Đang đóng gói</option>
              <option value="shipping">Đang vận chuyển</option>
              <option value="delivered">Đã giao hàng</option>
              <option value="refund_pending">Chờ hoàn tiền</option>
              <option value="refund_completed">Đã hoàn tiền</option>
              <option value="cancelled">Đã hủy</option>
            </select>
          </div>
          <hr />

          <div className="table-responsive mt-3">
            <table className="table table-bordered v-align">
              <thead className="thead-dark">
                <tr>
                  <th>ID</th>
                  <th>KHÁCH HÀNG</th>
                  {/* <th>TỔNG TIỀN</th> */}
                  <th>NGÀY ĐẶT</th>
                  <th>PHƯƠNG THỨC THANH TOÁN</th>
                  <th>TÌNH TRẠNG THANH TOÁN</th>
                  <th>TÌNH TRẠNG ĐƠN HÀNG</th>
                  <th>ACTION</th>
                </tr>
              </thead>

              <tbody>
                {orders.length > 0 ? (
                  orders.map((order) => (
                    <tr key={order.orderID}>
                      <td>{order.orderID}</td>
                      <td>{order.receiver || "Không có thông tin"}</td>
                      {/* <td>
                        {order.totalPrice
                          ? `${order.totalPrice.toLocaleString()} VND`
                          : "0 VND"}
                      </td> */}
                      <td>
                        {order.dateOrder
                          ? FormatDateHours(order.dateOrder)
                          : "Không có ngày đặt"}
                      </td>
                      <td>
                        <span
                          className={`payment-method-label ${order.paymentMethod
                            ?.replace(/\s+/g, "-")
                            .toLowerCase()}`}
                        >
                          {order.paymentMethod || "Không xác định"}
                        </span>
                      </td>

                      <td>{order.paymentStatus || "Không xác định"}</td>

                      <td>
                        {selectedStatus !== "refund_pending" &&
                          selectedStatus !== "refund_completed" && (
                            <div
                              className={`status-dropdown ${
                                openDropdown === order.orderID ? "open" : ""
                              }`}
                              onClick={() => {
                                setOpenDropdown(
                                  openDropdown === order.orderID
                                    ? null
                                    : order.orderID
                                );
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              <span
                                className={`status-label ${order.orderStatus
                                  .replace(/\s+/g, "-")
                                  .toLowerCase()}`}
                              >
                                {order.orderStatus || "Không xác định"}
                              </span>
                              {openDropdown === order.orderID && (
                                <ul className="dropdown-menu">
                                  {getOptions(order.orderStatus).map(
                                    (option, index) => (
                                      <li
                                        key={index}
                                        onClick={(e) => {
                                          if (!orderPermission) {
                                            e.preventDefault();
                                            Swal.fire({
                                                icon: 'error',
                                                title: 'Không có quyền',
                                                text: 'Bạn không có quyền cập nhật đơn hàng.',
                                            });
                                          }
                                          else {
                                            handleOptionClick(
                                              order.orderID,
                                              option,
                                              order.orderStatus
                                            )
                                          }
                                        }}
                                        
                                        style={{
                                          cursor: "pointer",
                                          padding: "5px",
                                        }}
                                      >
                                        {option}
                                      </li>
                                    )
                                  )}
                                </ul>
                              )}
                            </div>
                          )}

                        {/* Chỉ hiển thị nút "Hoàn tiền" nếu trạng thái là refund_pending */}
                        {selectedStatus === "refund_pending" && (
                          <button
                          
                            onClick={(e) => {
                              if (!orderPermission) {
                                e.preventDefault();
                                Swal.fire({
                                    icon: 'error',
                                    title: 'Không có quyền',
                                    text: 'Bạn không có quyền hoàn tiền cho đơn hàng đã hủy.',
                                });
                              }
                              else {
                                handleRefundAction(order.orderID)
                              }
                            }}
                            className="status-label chờ-xác-nhận"
                          >
                            Hoàn tiền
                          </button>
                        )}

                        {/* Hiển thị thông báo "Đã hoàn tiền" khi selectedStatus là refund_completed */}
                        {selectedStatus === "refund_completed" && (
                          <span className="status-label hoàn-tiền">
                            Đã hoàn tiền
                          </span>
                        )}
                      </td>

                      {showRefundModal && refundLink && (
                        <div className="order-details-backdrop">
                          <div className="order-details-content">
                            <div className="order-container-wrapper">
                              <div className="order-info-container">
                                <h3 className="title-list-address">
                                  QR hoàn tiền
                                </h3>
                                <div className="text-center">
                                  <img
                                    src={refundLink}
                                    alt="Refund QR Code"
                                    style={{ maxWidth: "35%", height: "auto" }}
                                  />
                                  {/* <a href={refundLink} target="_blank" rel="noopener noreferrer">
              Tải xuống
            </a> */}

                                  <div className="mt-2">
                                    <button
                                      className="status-label đã-giao"
                                      onClick={() =>
                                        handleRefundStatusChange("completed")
                                      }
                                    >
                                      Đã hoàn tiền
                                    </button>
                                    <hr />
                                    <button
                                      className="status-label đã-hủy"
                                      onClick={() =>
                                        handleRefundStatusChange("bank_error")
                                      }
                                    >
                                      Tài khoản ngân hàng không hợp lệ
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <button
                                onClick={() => closeRefundModal(false)}
                                className="modal-close"
                              >
                                <IoIosCloseCircle />
                              </button>
                            </div>
                          </div>
                        </div>
                      )}

                      <td>
                        <div className="actions align-items-center">
                          <Button
                            onClick={() => fetchOrderDetails(order.orderID)}
                            className="eye"
                            color="secondary"
                          >
                            {hiddenRows[order.orderID] ? (
                              <FaRegEyeSlash />
                            ) : (
                              <FaRegEye />
                            )}
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center">
                      Không có đơn hàng nào
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            {showCancelModal && (
              <div className="order-details-backdrop">
                <div className="order-details-content">
                  <div className="order-container-wrapper">
                    <div className="order-info-container">
                      <h3 className="title-list-address">Chọn lý do hủy đơn</h3>
                      <div className="text-left">
                        {cancelReasons.map((item, index) => (
                          <div key={index} className="radio-item">
                            <input
                              className="form-check-input"
                              type="radio"
                              id={`reason-${index}`}
                              name="cancelReason"
                              value={item.reason} // Lưu giá trị lý do
                              onChange={() =>
                                setSelectedReason({
                                  reasonID: item.reasonID,
                                  reason: item.reason,
                                })
                              }
                            />
                            <label
                              className="address-label"
                              htmlFor={`reason-${index}`}
                            >
                              {item.reason}
                            </label>
                          </div>
                        ))}
                        <div className="mt-3">
                          <button
                            className="status-label đã-hủy"
                            onClick={() =>
                              handleCancelOrder(cancelOrderID, selectedReason)
                            }
                            disabled={!selectedReason} // Vô hiệu hóa nếu chưa chọn lý do
                          >
                            Xác nhận hủy
                          </button>
                        </div>
                      </div>
                    </div>

                    <button
                      onClick={closeCancelReasonModal}
                      className="modal-close"
                    >
                      <IoIosCloseCircle />
                    </button>
                  </div>
                </div>
              </div>
            )}

            {isDetailsModalOpen && orderDetails && (
              <div className="order-details-backdrop">
                <div className="order-details-content">
                  {/* Wrapper cho hai container trên */}
                  <div className="order-container-wrapper">
                    {/* Container 1: Chi tiết đơn hàng + Thông tin giao hàng */}
                    <div className="order-info-container">
                      <h3 className="title-list-address">Chi tiết đơn hàng</h3>
                      <p>
                        <strong>ID đơn hàng:</strong> {orderDetails.orderID}
                      </p>
                      <p>
                        <strong>Trạng thái:</strong> {orderDetails.orderStatus}
                      </p>
                      <p>
                        <strong>Phương thức thanh toán:</strong>{" "}
                        {orderDetails.paymentMethod}
                      </p>

                      <p>
                        <strong>Người nhận:</strong>{" "}
                        {orderDetails.shippingInfo.receiver}
                      </p>
                      <p>
                        <strong>Email:</strong> {orderDetails.email}
                      </p>
                      <p>
                        <strong>Điện thoại:</strong>{" "}
                        {orderDetails.shippingInfo.phoneNumber}
                      </p>
                      <p>
                        <strong>Địa chỉ:</strong>{" "}
                        {orderDetails.shippingInfo.address}
                      </p>
                      <div className="order-fees">
                        <div className="order-fee-item">
                          <p>
                            <strong>Tổng tiền hàng:</strong>
                          </p>
                          <p>
                            {Formatter(
                              orderDetails.totalPrice - orderDetails.shippingFee
                            )}
                          </p>
                        </div>
                        <div className="order-fee-item">
                          <p>
                            <strong>Phí vận chuyển:</strong>
                          </p>
                          <p>{Formatter(orderDetails.shippingFee)}</p>
                        </div>
                        <div className="order-fee-item">
                          <p>
                            <strong>Thành tiền:</strong>
                          </p>
                          <p>{Formatter(orderDetails.totalPrice)}</p>
                        </div>
                      </div>
                    </div>

                    {/* Container 2: Lịch sử trạng thái đơn hàng */}
                    <div className="order-history-container">
                      <h4 className="title-list-address">
                        Lịch sử trạng thái đơn hàng
                      </h4>
                      <ul>
                        {orderDetails.orderStatusHistory.map(
                          (history, index) => (
                            <li key={index}>
                              <strong>{history.status}:</strong>{" "}
                              {new Date(history.dateUpdated).toLocaleString()}
                            </li>
                          )
                        )}
                      </ul>

                      {orderDetails.refundDetail && (
                        <div className="refund-details">
                          <br />
                          <h4 className="title-list-address">
                            Thông tin hoàn tiền
                          </h4>

                          <span>
                            {" "}
                            Ngân hàng {
                              orderDetails.refundDetail.bankShortName
                            }{" "}
                            STK {orderDetails.refundDetail.accountNumber} -{" "}
                            {orderDetails.refundDetail.accountName}
                          </span>
                          <p style={{ margin: 0 }}>
                            <strong>Trạng thái:</strong>{" "}
                            {orderDetails.refundDetail.status}
                          </p>
                          <p style={{ margin: 0 }}>
                            <strong>Ngày hoàn tiền: </strong>
                            {orderDetails.refundDetail.refundedAt
                              ? new Date(
                                  orderDetails.refundDetail.refundedAt
                                ).toLocaleString()
                              : "Chưa hoàn tiền"}
                          </p>
                          <br />
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Container 3: Danh sách sản phẩm */}
                  <div className="order-items-container">
                    <h4 className="title-list-address">Danh sách sản phẩm</h4>
                    <ul>
                      {orderDetails.items.map((item) => (
                        <li key={item.id} className="product-item">
                          <img
                            src={item.imageLink}
                            alt={item.title}
                            className="product-image"
                          />
                          <span className="product-title">{item.title}</span>
                          <span className="product-quantity">
                            {" "}
                            - SL: {item.quantity}
                          </span>
                          <span className="product-price">
                            - Giá: {item.discountedPrice.toLocaleString()} VND
                          </span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  {/* Close button */}
                  <button
                    onClick={() => setIsDetailsModalOpen(false)}
                    className="modal-close"
                  >
                    <IoIosCloseCircle />
                  </button>
                </div>
              </div>
            )}

            <div className="tableFooter">
              <div className="paginationn">
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 0}
                  className="pagination-arrow"
                >
                  «
                </button>

                {[...Array(totalPages)].map((_, index) => (
                  <button
                    key={index}
                    onClick={() => handlePageChange(index)}
                    className={currentPage === index ? "active" : ""}
                  >
                    {index + 1}
                  </button>
                ))}

                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages - 1}
                  className="pagination-arrow"
                >
                  »
                </button>
              </div>
            </div>
          </div>
          {isLoading && (
            <div className="modal">
              <div className="overlay_loading">
                <div className="modal-content_loading">
                  <div className="d-flex">
                    <PacmanLoader color="#5e2e86" />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
export default OrderList;
